<div class="kz-media-kaza" #elementView>
	<h3 class="kz-media-kaza--title">
		<kz-icons name="photo_2"></kz-icons>
		<span i18n="@@publication.uploadKaza">Photos of my Kaza</span>
  </h3>
  <div class="kz-media-kaza--categorys-container" *ngIf="showMenu">
  	<div class="kz-media-kaza--categorys">
      <kz-icons name="arrowdown"></kz-icons>
      <div *ngIf="!type && pictures.length" class="kz-media-kaza--categorys-current" (click)="menuOpen = !menuOpen" i18n="@@publication.typesAll">All <span>({{totalCount}})</span></div>
      <div *ngIf="type && pictures.length" class="kz-media-kaza--categorys-current" (click)="menuOpen = !menuOpen"><span i18n="@@publication.types">{type, select, post_pictures {Pictures} post_before_after {Before/After} post_event {Event} post_question {Question} post_survey {Survey} post_idea {Idea}}</span></div>
  		<ul *ngIf="types.length" class="kz-media-kaza--categorys-list" [ngClass]="{'kz-media-kaza--categorys-list--open': menuOpen}">
  			<li (click)="loadMedias()" [ngClass]="{'selected': !type}" i18n="@@publication.typesAll">All <span>({{totalCount}})</span></li>
  			<li (click)="loadMedias(item.type)" [ngClass]="{'selected': type == item.type }" *ngFor="let item of types" ><span i18n="@@publication.types">{item.type, select, post_pictures {Pictures} post_before_after {Before/After} post_event {Event} post_question {Question} post_survey {Survey} post_idea {Idea}}</span> <span>({{ item.count }})</span></li>
  		</ul>
  	</div>
  </div>
  <div *ngIf="!loading && pictures.length == 0" i18n="@@publication.kazaEmpty" class="kz-media-kaza--empty">No photo available</div>
  <div class="kz-media-kaza--photos" [ngClass]="{'kz-media-kaza--photos-full': !showMenu}">

    <ul *ngIf="pictures.length && medias">
			<li *ngFor="let item of pictures" (click)="onSelectMedia(item)" [ngStyle]="{'background-image': 'url('+ item.thumbs.small + ')' }" [ngClass]="{'selected' : medias | indexOf: {item: item['@id']}}">
        <span class="kz-media-kaza--index">{{ medias | indexOf: {item: item['@id']} }}</span>
      </li>
    </ul>

    <ul *ngIf="pictures.length && !medias">
			<li *ngFor="let item of pictures" (click)="onSelectMedia(item)" [ngStyle]="{'background-image': 'url('+ item.thumbs.small + ')' }" [ngClass]="{'selected' : media?.from == item['@id']}">
        <span class="kz-publish-makaza--index">1</span>
      </li>
		</ul>
    <div *ngIf="loading" class="kz-media-kaza--loading"></div>
  </div>
</div>
